const baseUrl = `${process.env.REACT_APP_API_URL}/api`;
const msApiUrl = process.env.REACT_APP_MS_API_URL;
const segaUrl = process.env.REACT_APP_SEGA_URL;
const cdnHost = process.env.REACT_APP_CDN_HOST;

export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

const API = {
  auth: {
    login: `${process.env.REACT_APP_API_URL}/apptoken`,
    recover: `${baseUrl}/customeradmin/sendrecoverypassword?Email=`,
    confirm: `${baseUrl}/customeradmin/recoverypassword`,
  },
  profile: {
    load: `${baseUrl}/profile/load`,
  },
  globals: {
    packageType: `${msApiUrl}/packages/parametrics/packageType`,
    packageSize: `${msApiUrl}/packages/parametrics/packageSize`,
    packageStatus: `${msApiUrl}/packages/parametrics/packageStatus`,
    deliveryTerm: `${msApiUrl}/packages/parametrics/deliveryTerm`,
    notifierType: `${msApiUrl}/mkp/parametrics/notifierType`,
    countries: `${baseUrl}/geolocation/loadcountries`,
    cities: `${baseUrl}/geolocation/loadcities`,
    roles: `${baseUrl}/apptype/userrole`,
    userType: `${baseUrl}/apptype/usertype`,
  },
  marketplaces: {
    get: `${msApiUrl}/mkp/marketplace`,
  },
  massive: {
    list: `${msApiUrl}/packages/massive`,
    packagesUpload: (userId) =>
      `${msApiUrl}/caronte/integration/${userId}/massive`,
    packagesDownload: `${cdnHost}/assets/bulk-import.xlsx`,
  },
  segaMassive: {
    root: `${segaUrl}/api/massive`,
    byId: (id) => `${segaUrl}/api/massive/${id}`,
    errors: (id) => `${segaUrl}/api/massive/${id}/errors`,
    labels: (id) => `${segaUrl}/api/massive/${id}/labels`,
    packages: (id) => `${segaUrl}/api/massive/${id}/packages`,
    packageByTracking: (id, tracking) =>
      `${segaUrl}/api/massive/${id}/packages/${tracking}`,
    packageLabel: (id, tracking) =>
      `${segaUrl}/api/massive/${id}/packages/${tracking}/label`,
    cancel: (id) => `${segaUrl}/api/massive/${id}/cancel`,
    cancelPackage: (id, tracking) =>
      `${segaUrl}/api/massive/${id}/packages/${tracking}/cancel`,
    template: `${segaUrl}/api/massive/template`,
  },
  segaShipment: {
    create: `${segaUrl}/api/shipment`,
    label: (tracking) => `${segaUrl}/api/shipment/${tracking}/label`,
  },
  packages: {
    get: `${msApiUrl}/packages/packages`,
    getById: `${msApiUrl}/packages/packages/`,
    history: `${msApiUrl}/packages/packages/history`,
    send: `${msApiUrl}/packages/packages`,
    getByExternalCode: `${msApiUrl}/packages/packages/findByExternalCode/`,
    withoutZone: `${msApiUrl}/packages/packages/withoutzone`,
    label: `${msApiUrl}/labels/packages/`,
    labelByMassive: (code) => `${msApiUrl}/labels/packages/massive/${code}`,
    getByMassiveCode: `${msApiUrl}/packages/massive/packages/list`,
    getLabels: `${msApiUrl}/labels/packages/packagesLabels/`,
    getNormalByStoreId: (storeId) =>
      `${msApiUrl}/packages/packages/packagesByStoreId/${storeId}`,
    getHistoryByStoreId: (storeId) =>
      `${msApiUrl}/packages/packages/packagesHistoryByStoreId/${storeId}`,
    downloadDeliveryNoteById: (id) =>
      `${msApiUrl}/labels/packages/remittance/${id}`,
  },
  stores: {
    get: `${msApiUrl}/mkp/store`,
    create: `${msApiUrl}/mkp/store`,
  },
  zones: {
    getAllByLogisticOperator: (id) =>
      `${msApiUrl}/zones/logistics_operator/${id}`,
    resolve: `${msApiUrl}/mediator/resolveZone`,
  },
  user: {
    create: `${baseUrl}/customeradmin/create`,
    getAll: `${baseUrl}/customeradmin/getall/`,
    get: `${baseUrl}/customeradmin/get?id=`,
    update: `${baseUrl}/customeradmin/update`,
    delete: `${baseUrl}/customeradmin/delete?id=`,
    changePassword: `${baseUrl}/customeradmin/sendrecoverypassword`,
  },
  paquer: {
    get: `${msApiUrl}/pqr/paquer/`,
  },
  alert: `${msApiUrl}/fe/messages`,
  reports: {
    packages: `${msApiUrl}/reports/report`,
    history: `${msApiUrl}/reports/report/history`,
    withoutZone: `${msApiUrl}/reports/report/withoutzone`,
    storePackages: `${msApiUrl}/reports/report/store`,
    storeHistoryPackages: `${msApiUrl}/reports/report/store/history`,
  },
  addresses: {
    calculate: `${msApiUrl}/mediator/address/calculate`,
    alternativesByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/address`,
    recalculate: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/address/calculate`,
    addressByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/address/current`,
    historyByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/address/history`,
  },
  delivery: {
    entriesByShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/delivery/entries`,
  },
  physicalAttributes: {
    byShipmentId: (shipmentId) =>
      `${msApiUrl}/mediator/shipment/${shipmentId}/dimensions`,
  },
};

export default API;
